/**
 * Sets the tax total in the state.
 *
 * @param {Object} state - The Vuex state object.
 * @param {number} taxTotal - The new tax total value.
 */
/**
 * Mutations for the checkout store module.
 * @module checkout/mutations
 */

export default {
  /**
   * Set the tax total in the state.
   * @param {Object} state - The Vuex state object.
   * @param {number} taxTotal - The tax total value to be set.
   */
  setTaxTotal: (state, taxTotal) => {
    state.taxTotal = taxTotal;
  },

  /**
   * Set the project ID in the state.
   * @param {Object} state - The Vuex state object.
   * @param {string} projectId - The project ID to be set.
   */
  setProjectId: (state, projectId) => {
    state.projectId = projectId;
  },

  /**
   * Set the client secret in the state.
   * @param {Object} state - The Vuex state object.
   * @param {string} clientSecret - The client secret to be set.
   */
  setClientSecret: (state, clientSecret) => {
    state.clientSecret = clientSecret;
  },

  /**
   * Set the payment intent ID in the state.
   * @param {Object} state - The Vuex state object.
   * @param {string} paymentIntentId - The payment intent ID to be set.
   */
  setPaymentIntentId: (state, paymentIntentId) => {
    state.paymentIntentId = paymentIntentId;
  },

  /**
   * Reset the checkout state.
   * @param {Object} state - The Vuex state object.
   */
  resetCheckout: (state) => {
    state.projectId = 0;
    state.shippingTotal = 0;
    state.taxTotal = 0;
    state.clientSecret = '';
  }
};
